
$('.js-read-more').on('click', function (e) {
  e.preventDefault()
  const $this = $(this)
  $this.toggleClass('is-active')

  $this.closest('section').find('.box__hidden-content').slideToggle()

  if ($this.hasClass('is-active')) {
    $this.find('span').text('Read less')
  } else {
    $this.find('span').text('Read more')

  }
})

$('.js-slider-solutions .slider__slide').on('click', function (){
  $('.media[data-media-index="' + $(this).data('target') + '"]').addClass('is-visible').siblings().removeClass('is-visible')
})
